import React, { Component } from 'react';
import { getTopUsuarios } from "../../../utils/petitions"
import Loader from 'react-loader-spinner';
import Button from 'react-bootstrap/Button';
import ReactDatePicker from 'react-datepicker';
import { MdPictureAsPdf, MdFileDownload } from "react-icons/md";
import xlsx from 'node-xlsx';
import download from 'downloadjs';
//import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'
import HiddenAlert from "../../components/HiddenAlert";

var utf8 = require('utf8');

class ReporteTopUsuario extends Component {

    state = {
        pasajeros: [],
        loading: true,
        loadingInicio: true,
        error: false,
        errorText: "",
    }

    componentDidMount() {
        //this.getData()
        this.setState({ startDate: new Date() });
    }

    setDefaultItems = () => {
        this.setState({
            error: false,
            errorText: "",
        })
    }

    generarPDF = async () => {
        this.setDefaultItems();
        try {
            await this.getData(this.state.startDate);
            if (this.state.pasajeros) {
                this.setState({ loading: false });
                const pdf = new jsPDF();
                autoTable(pdf, { html: '#my-table' })
                pdf.save('Reporte.pdf');
                this.setState({ loading: true });
            } else {
                this.setState({
                    error: true,
                    errorText: "No se pudo generar el reporte, revise las fechas"
                })
            }
        } catch (error) {
            throw Error(error);
        }
    }

    obtenerDatosImportarXLSX = async () => {
        let valores = [];
        let headers = ["Documento", "Nombre", "Cantidad"];
        valores.push(headers);
        this.state.pasajeros.forEach(element => {
            let rows = [element.ci, utf8.decode(element.nombrepasajero), element.cantidad];
            valores.push(rows);
        });
        return valores;
    }

    generarExcel = async () => {
        this.setDefaultItems();
        try {
            await this.getData(this.state.startDate);
            if (this.state.pasajeros) {
                const qwerty = await this.obtenerDatosImportarXLSX();
                let buffer = xlsx.build([{ name: "Reporte", data: qwerty }]).toString('base64');
                download(atob(buffer), 'Reporte.xlsx', { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            } else {
                this.setState({
                    error: true,
                    errorText: "No se pudo generar el reporte, revise las fechas"
                })
            }
        } catch (error) {
            throw Error(error);
        }
    }

    getData = async (fecha) => {
        const header = `token=${localStorage.getItem("token")}, email=${localStorage.getItem("email")}`
        const response = await getTopUsuarios(header, fecha);
        if (response.status === 200) {
            this.setState({
                pasajeros: response.data.pasajeros,
            })
        } else if (response.status === 401) {
            localStorage.clear();
            this.props.history.push("/")
        } else {
            console.log(response)
        }
    }

    onChangeDate = (date) => {
        let newDate = new Date(date)
        this.setState({ startDate: newDate });
    }

    render() {

        const ExampleCustomInput = React.forwardRef(({ value, onClick }, ref) => (
            <Button onClick={onClick} size="sm" variant="secondary" ref={ref} >
                {value}
            </Button>
        ));

        return (
            <div className="container-fluid">
                <HiddenAlert visible={this.state.error} text={this.state.errorText} variant="danger" />
                {!this.state.loadingInicio ?
                    <div>
                        <Loader
                            className="centered"
                            type="Circles"
                            color="#000"
                            visible={this.state.loading}
                            height={50}
                            width={50}
                        />
                        <h6 className="centeredTwo">Cargando...</h6>
                    </div>
                    :
                    <div>
                        <div className="d-flex">
                            <h4 className="mr-1">Cantidad de solicitudes por usuario desde una fecha</h4>
                        </div>
                        <hr className="mt-2" />
                        <div class="row justify-content-center align-items-center mt-5">
                            <h6 className="mr-1">Selecciona la fecha:</h6>
                        </div>
                        <div class="row justify-content-center align-items-center mt-3">
                            <div class="col-1 d-flex justify-content-center">
                                <ReactDatePicker
                                    selected={this.state.startDate}
                                    onChange={(date) => this.onChangeDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    locale="es"
                                    customInput={<ExampleCustomInput />}
                                />
                            </div>
                        </div>
                        <div class="row justify-content-center align-items-center mt-3">
                            <h6 className="mr-1">Descarga el reporte</h6>
                        </div>
                        <div class="row justify-content-center align-items-center mt-3">
                            <div class="col-3 d-flex justify-content-center">
                                <Button onClick={this.generarPDF} size="sm" className="ml-3" variant="danger" >
                                    <MdPictureAsPdf className="mr-1 mb-1" />
                                    Descargar PDF
                                </Button>
                                <Button onClick={this.generarExcel} size="sm" className="ml-3" variant="success" >
                                    <MdFileDownload className="mr-1 mb-1" />
                                    Descargar Excel
                                </Button>
                            </div>
                        </div>
                        {!this.state.loading ?
                            <div id="divToPrint" className="mt4 table-responsive" style={{
                                backgroundColor: '#f5f5f5',
                                width: '210mm',
                                minHeight: '297mm',
                                marginLeft: 'auto',
                                marginRight: 'auto'
                            }}>
                                <table class="table" id="my-table">
                                    <thead>
                                        <tr>
                                            {/*<th scope="col">#</th>*/}
                                            <th scope="col">Documento</th>
                                            <th scope="col">Nombres</th>
                                            <th scope="col">Cantidad de solicitudes</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.pasajeros.map((element, index) => (
                                            <tr key={index}>
                                                {/*<td>{index}</td>*/}
                                                <td>{element.ci}</td>
                                                <td>{utf8.decode(element.nombrepasajero)}</td>
                                                <td>{element.cantidad}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            : null
                        }
                    </div>
                }
            </div>
        );
    }
}

export default ReporteTopUsuario;